/* tslint:disable */

declare var Object: any;
export interface AttendanceReportInterface {
  "id"?: number;
}

export class AttendanceReport implements AttendanceReportInterface {
  "id": number;
  constructor(data?: AttendanceReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AttendanceReport`.
   */
  public static getModelName() {
    return "AttendanceReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AttendanceReport for dynamic purposes.
  **/
  public static factory(data: AttendanceReportInterface): AttendanceReport{
    return new AttendanceReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AttendanceReport',
      plural: 'AttendanceReports',
      path: 'AttendanceReports',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/AttendanceReport.ts